

















// import this to use this. in methods
import { defineComponent, ref, onMounted, watch } from '@nuxtjs/composition-api'

// common
import { parseElasticTextObject } from '@/common/utils/parsing'

// Composable
import useSearch from '@/composables/search/useSearch'

// Types
import { ApplicationKeyInterface } from '@/types/search/searchTypes'
import { ElasticFieldsInterface } from '@/types/search/elasticTypes'

export default defineComponent({
  props: {
    applications: {
      type: [String, Array],
      required: false,
      default: '',
    },
    activeChicklet: {
      required: false,
      type: String,
      default: '',
    },
    id: {
      required: true,
      type: String,
    },
    fields: {
      required: true,
      type: Object as () => ElasticFieldsInterface,
    },
  },

  emits: ['showApplicationInfo'],

  setup(props) {
    const { infoPanelsOpen, infoPanelOpenIDs } = useSearch()

    if (typeof props.applications === 'string') {
      return props.applications.split(',')
    }

    // variables
    const allApplications = ['WB', 'IHC', 'IF', 'F', 'ChIP', 'ELISA']
    const applicationKeys = ref<ApplicationKeyInterface[]>([])

    // methods
    const applicationIsActive = (application: ApplicationKeyInterface) => {
      return application.active
    }

    const applicationIsClickable = (application: ApplicationKeyInterface): boolean => {
      return application.clickable
    }

    const isClicked = (application: ApplicationKeyInterface) => {
      return (
        props.activeChicklet === application.chiclet &&
        infoPanelsOpen.value === true &&
        infoPanelOpenIDs.value.includes(props.id)
      )
    }

    const optionalChicletClasses = (application: ApplicationKeyInterface): string => {
      let classesString = ''

      classesString += applicationIsActive(application) ? 'active ' : ''
      classesString += isClicked(application) ? 'clicked ' : ''
      classesString += applicationIsClickable(application) === true ? 'clickable ' : ''

      return classesString
    }

    const showApplicationKeys = () => {
      // go over the chiclet we want to show
      // for each chiclet, check if this matches with the application prop chiclet
      // if so, add that object
      // if not, add an object with only the chiclet parameter

      if (props.fields?.chiclets?.raw === undefined) {
        return
      }

      const itemChicletsObject = parseElasticTextObject(props.fields?.chiclets?.raw)
      const itemChiclets = Object.keys(itemChicletsObject)

      allApplications.forEach((application: string) => {
        // if no chiclet field, return the chiclet
        if (props.fields.chiclets === undefined) {
          return application
        }

        if (itemChiclets.includes(application)) {
          const insertObj = {
            chiclet: application,
            active: true,
            clickable: Object.keys(itemChicletsObject[application]).length > 0,
          } as ApplicationKeyInterface

          applicationKeys.value.push(insertObj)
        } else {
          const insertObj = {
            chiclet: application,
            active: false,
            clickable: false,
          } as ApplicationKeyInterface
          applicationKeys.value.push(insertObj)
        }
      })
    }

    onMounted(() => {
      showApplicationKeys()
    })

    watch(props, () => {
      applicationKeys.value = []
      showApplicationKeys()
    })

    return {
      allApplications,
      optionalChicletClasses,
      applicationIsClickable,
      applicationKeys,
      infoPanelsOpen,
    }
  },
})
